export const API_ENDPOINTS = {
  ASSETINFO: {
    FETCH: '/assetinfo/fetch',
    GET: '/assetinfo/get',
    CREATE: '/assetinfo/create',
    UPDATE: '/assetinfo/update',
    DELETE: '/assetinfo/delete',
    SEARCH: '/assetinfo/search'
  },
  CONFIGUREDASSETS: {
    FETCH: '/configuredassets/fetch',
    GET: '/configuredassets/get',
    UPDATE: '/configuredassets/update',
    SEARCH: '/configuredassets/search',
    CREATE: '/configuredassets/create',
    DELETE: '/configuredassets/delete',
    DELETESTAGE: '/configuredassets/deletestage',
  },
  MAPPEDASSETS: {
    FETCH: '/mappedassets/fetch',
    GET: '/mappedassets/get',
    GETFORSTAGE: '/mappedassets/getforstage',
    GETMAPPINGID: '/mappedassets/getmappingid',
    UPDATE: '/mappedassets/update',
    SEARCH: '/mappedassets/search',
    CREATE: '/mappedassets/create',
    CREATEFORUPDATE: '/mappedassets/createforupdate',
    DELETEFORCREATE: '/mappedassets/deleteforcreate',
    FINISH: '/mappedassets/finish',
    DELETEFORUPDATE: '/mappedassets/deleteforupdate',
  },
  SYSTEMASSETS: {
    FETCH: '/systemassets/fetch',

  },
  DASHBOARD: {
    FETCH: '/dashboard/fetch',
    // FETCHCHARTDATA: '/dashboard/fetchchartdata'
  },

  REPORTS: {
    FETCH: '/reports/fetch',
    FETCHCHARTDATA: '/reports/fetchchartdata',
    DATA_ASSET_INVENTORY_REPORT: '/reports/datassetinventoryreport',
    PROTECTION_PROGRAM_STATUS_REPORT: '/reports/protectionprogramstatusreport',
  },

  CONFIGURATIONDROPDOWN: {
    //Data-classification
    FETCHDATACLASSIFICATION: '/configurationdropdown/dataclassification/fetch',
    UPDATEDATACLASSIFICATION: '/configurationdropdown/dataclassification/update',
    CREATEDATACLASSIFICATION: '/configurationdropdown/dataclassification/create',
    //Asset-Risk_level
    FETCHASSETRISKLEVEL: '/configurationdropdown/assetrisklevel/fetch',
    UPDATEASSETRISKLEVEL: '/configurationdropdown/assetrisklevel/update',
    CREATEASSETRISKLEVEL: '/configurationdropdown/assetrisklevel/create',
    //Data-Asset-Type
    FETCHDATAASSETTYPE: '/configurationdropdown/dataassettype/fetch',
    UPDATEDATAASSETTYPE: '/configurationdropdown/dataassettype/update',
    CREATEDATAASSETTYPE: '/configurationdropdown/dataassettype/create',
    //Regime
    FETCHREGIME: '/configurationdropdown/regime/fetch',
    UPDATEREGIME: '/configurationdropdown/regime/update',
    CREATEREGIME: '/configurationdropdown/regime/create',
  },


  DATAASSETMAPPINGS: {
    FETCH_DATA_ASSETS_WITH_MAPPING_STATUS:
      '/dataassetmapping/fetchdataassetswithmappingstatus',
    FETCH_DATA_ASSETS_WITH_MAPPING_STATUS_SEARCH:
      '/dataassetmapping/fetchdataassetswithmappingstatussearch',
    FETCH_SYSTEM_ASSETS_FOR_MAPPING:
      '/dataassetmapping/fetchsystemassetsformapping',
    FETCH_SYSTEM_ASSETS_FOR_MAPPING_SEARCH:
      '/dataassetmapping/fetchsystemassetsformappingsearch',
    FETCH_SECURITY_ZONES:
      '/dataassetmapping/fetchsecurityzones',
    FETCH_SECURITY_ZONES_SEARCH:
      '/dataassetmapping/fetchsecurityzonessearch',
    FETCH_MAPPING_DETAILS_BY_DATA_ASSET_ID:
      '/dataassetmapping/fetchmappingdetailsbydataassetid',
    CREATE_MAPPING:
      '/dataassetmapping/createmapping',
    UPDATE_MAPPING:
      '/dataassetmapping/updatemapping',
    FETCH_MAPPED_SYSTEM_ASSETS_BY_DATA_ASSET_ID:
      '/dataassetmapping/fetchmappedsystemassetsbydataassetid',
    FETCH_MAPPED_SYSTEM_ASSETS_BY_DATA_ASSET_ID_SEARCH:
      '/dataassetmapping/fetchmappedsystemassetsbydataassetidsearch',
    FETCH_MAPPED_SECURITY_ZONES_BY_DATA_ASSET_ID:
      '/dataassetmapping/fetchmappedsecurityzonesbydataassetid',
    FETCH_MAPPED_SECURITY_ZONES_BY_DATA_ASSET_ID_SEARCH:
      '/dataassetmapping/fetchmappedsecurityzonesbydataassetidsearch',
    FETCH_SYSTEM_ASSETS_BY_SECURITY_ZONE_ID:
      '/dataassetmapping/fetchsystemassetsbysecurityzoneid',
    FETCH_SYSTEM_ASSETS_BY_SECURITY_ZONE_ID_SEARCH:
      '/dataassetmapping/fetchsystemassetsbysecurityzoneidsearch',
    FETCH_MAPPED_PARTIAL_SECURITY_ZONES_BY_DATA_ASSET_ID:
      '/dataassetmapping/fetchmappedpartialsecurityzonesbydataassetid'
  },

 DATAPROTECTIONPROGRAM: {
  FETCH_MAPPED_DATA_ASSETS_WITH_PROGRAM_STATUS:
    '/dataprotectionprogram/fetchmappeddataassetswithprogramstatus',
  FETCH_MAPPED_DATA_ASSETS_WITH_PROGRAM_STATUS_SEARCH:
    '/dataprotectionprogram/fetchmappeddataassetswithprogramstatussearch',

  // Step 1: Program Details
  CREATE_PROGRAM_DETAILS:
    '/dataprotectionprogram/createprogramdetails',
  FETCH_PROGRAM_DETAILS_BY_MAPPING_ID:
    '/dataprotectionprogram/fetchprogramdetailsbymappingid',
  UPDATE_PROGRAM_DETAILS:
    '/dataprotectionprogram/updateprogramdetails',

  // Step 2: Implementation Details
  CREATE_IMPLEMENTATION_DETAILS:
    '/dataprotectionprogram/createimplementationdetails',
  FETCH_IMPLEMENTATION_DETAILS_BY_PROGRAM_ID:
    '/dataprotectionprogram/fetchimplementationdetailsbyprogramid',
  UPDATE_IMPLEMENTATION_DETAILS:
    '/dataprotectionprogram/updateimplementationdetails',

  // Step 3: Verification Details
  CREATE_VERIFICATION_DETAILS:
    '/dataprotectionprogram/createverificationdetails',
  FETCH_VERIFICATION_DETAILS_BY_PROGRAM_ID:
    '/dataprotectionprogram/fetchverificationdetailsbyprogramid',
  UPDATE_VERIFICATION_DETAILS:
    '/dataprotectionprogram/updateverificationdetails',

  FETCH_COMPLETED_PROGRAM_DETAILS_BY_MAPPING_ID:
    '/dataprotectionprogram/fetchcompletedprogramdetailsbymappingid',
},

};